import React from 'react';
import ReactDOM from 'react-dom';
require('./styles/PrintForm.css');
class PrintReportDialog extends React.Component {


  constructor(props) {
    super(props);
    this.parent = props.parent;  
    this.state = {sources:[props.reportList],printTaskId:props.printTaskId};
  }

  getFieldsList(sources)
  {
    let optionList = [];
    for(let key in sources)
    {
      let source = sources[key];
      for(let k in source){
        optionList.push(

          <div className="panel panel-default dataSourceFieldListItem"  title={source[k]['name']} data-sourceid={source[k]['id']}  onClick={this.itemClick.bind(this)}>
		                      <div className="panel-heading" role="tab" title={source[k]['name']} data-sourceid={source[k]['id']} >
		                          <h4 className="panel-title" title={source[k]['name']} data-sourceid={source[k]['id']} >
		                              <a role="button" data-toggle="collapse" data-parent="#accordion"
		                                href="#" aria-expanded="true" aria-controls="collapseOne"   title={source[k]['name']} data-sourceid={source[k]['id']} >
		                                  {source[k]['name']}
		                              </a>
		                          </h4>
		                      </div>
		                  </div>
        );

      }
 
    }
    return optionList;
  }

  itemClick(e)
  {
    let id = $(e.target).attr("data-sourceid");
    window.printReportTaskId = this.state.printTaskId;
    window.printReportId = id;
    var task = {taskId :this.state.printTaskId, reportId:id};
    this.closeAttachmentHandler();
    window.doPrintReport(task,null);
  }

  componentDidMount () {
    $("#printReportDialogModel .modal").children(':first').draggable({ cursor: "move", containment: "parent" });
  }


  render () {
    let optionList = this.getFieldsList(this.state.sources); 
    let _outerStyle =  {width:'100%',flexShrink:'0',display:'flex',flexDirection:'column',alignSelf:'stretch',overflow:'hidden',backgroundColor: 'white'};
    let _style =  {flexGrow:100,flexShrink:'0',display:'flex',flexDirection:'column',
                   alignSelf:'stretch',overflowY:'auto',overflowX:'hidden',textOverflow:'ellipsis'};
    if(this.state.height)
      _style.height =  $(this.sourcesContainer).height()+"px";
   
    
    return (
      <div className="modal " style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div className=" ui-draggable" style={{ alignSelf: "center", display: 'flex', flexFlow: 'column', background: "#ffffff", background: '#FFFFFF', border: '1px solid #9B9B9B', boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)', borderRadius: '2px', width: '300px', height: '305px' }}>
          <div className="modal-header" style={{ position: "relative" }}>
            <div className="modal-close" onClick={this.closeAttachmentHandler.bind(this)}></div>
            <h5 className="modal-title">样式列表</h5>
          </div>
          <div style={{height:'100%'}} >
            <div style={{display:'flex',flexDirection:'row',flexGrow:100,height:'270px'}}>
              {/* <div className="dataSourceListOuter" style={_outerStyle}>
                <div className="dataSourceListContainer" ref={node=>this.sourcesContainer=node}  style={_style}>
                {optionList}
                </div>     
              </div> */}
                          <div className="container" style={{overflow:'auto'}}>
                            <div className="row" style={{ marginRight: '-10px',marginLeft: '-10px'}}>
                                <div>
                                    <div className="panel-group" id="accordion" style={{paddingTop:'3px'}} role="tablist" aria-multiselectable="true" ref={node=>this.sourcesContainer=node}>
                                            {optionList}
                                    </div>
                                </div>
                            </div>
                        </div>     
            </div>  
          </div>
        </div> 
      </div>
    );
  }
  closeAttachmentHandler () {
    //关掉要卸载
    let $reactComponentContainer = $("#printReportDialogModel .modal");
    ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
    $reactComponentContainer.remove();
  }
}

PrintReportDialog.defaultProps = {
  

};

export default PrintReportDialog;



// WEBPACK FOOTER //
// ./src/components/dialogPrintReport/PrintReportDialog.js